export const getCurrencySymbol = (currencyCode: string): string => {
    switch (currencyCode?.toUpperCase()) {
        case 'EUR': return '€';
        case 'USD': return '$';
        case 'GBP': return '£';
        case 'MAD': return 'MAD';
        default: return '€'; // Default
    }
};

export const formatCurrency = (amount: number, currencyCode: string = 'EUR'): string => {
    const symbol = getCurrencySymbol(currencyCode);
    const formattedAmount = (amount || 0).toFixed(2);

    // For MAD, put it after the number usually
    if (currencyCode === 'MAD') {
        return `${formattedAmount} ${symbol}`;
    }

    return `${symbol}${formattedAmount}`;
};
